var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleAuthenticator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 106,
    viewBox: "0 0 260 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_50653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.005 183.01C201.805 183.01 260.01 124.805 260.01 53.0052C260.01 -18.7947 201.805 -77 130.005 -77C58.2053 -77 0 -18.7947 0 53.0052C0 124.805 58.2053 183.01 130.005 183.01Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 135.733C84.3096 135.733 47.2775 98.7008 47.2775 53.0052C47.2775 7.30958 84.3096 -29.7225 130.005 -29.7225C152.843 -29.7225 173.522 -20.4619 188.502 -5.4919L221.931 -38.9203C198.402 -62.4491 165.896 -77 130.005 -77C58.2038 -77 0 -18.7962 0 53.0052C0 124.807 58.2038 183.01 130.005 183.01C165.906 183.01 198.402 168.459 221.941 144.941L188.513 111.513C173.522 126.472 152.843 135.733 130.005 135.733Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.733 53.0054H171.364C171.364 30.168 152.843 11.6362 129.995 11.6362C107.147 11.6362 88.6361 30.1575 88.6361 53.0054C88.6361 64.1307 93.036 74.2189 100.191 81.6673L100.16 81.6987L151.376 132.915L151.386 132.926C186.711 123.497 212.733 91.2946 212.733 53.0054Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260 53.0051H212.723C212.723 91.2943 186.69 123.497 151.386 132.925L187.895 169.434C230.636 148.136 260 104.002 260 53.0051Z",
    fill: "#616161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 181.523C58.4552 181.523 0.419034 123.717 0.0104759 52.2615C0.0104759 52.5129 0 52.7538 0 53.0053C0 124.807 58.2038 183.01 130.005 183.01C201.807 183.01 260.01 124.807 260.01 53.0053C260.01 52.7538 260 52.5129 260 52.2615C259.591 123.717 201.545 181.523 130.005 181.523Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.397 132.925L152.549 134.078C187.266 124.272 212.733 92.3629 212.733 54.4822V53.0051C212.733 91.2943 186.701 123.497 151.397 132.925Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.372 41.1838H130.001C123.474 41.1838 118.184 46.4741 118.184 53.0006C118.184 59.527 123.474 64.8174 130.001 64.8174H236.362C242.888 64.8174 248.179 59.527 248.179 53.0006C248.189 46.4741 242.899 41.1838 236.372 41.1838Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M236.372 41.1838H130.001C123.474 41.1838 118.184 46.4741 118.184 53.0006C118.184 59.527 123.474 64.8174 130.001 64.8174H236.362C242.888 64.8174 248.179 59.527 248.179 53.0006C248.189 46.4741 242.899 41.1838 236.372 41.1838Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6335 61.8677C28.5282 61.8677 32.4961 57.8998 32.4961 53.0051C32.4961 48.1105 28.5282 44.1426 23.6335 44.1426C18.7388 44.1426 14.7709 48.1105 14.7709 53.0051C14.7709 57.8998 18.7388 61.8677 23.6335 61.8677Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 42.6656H236.367C242.642 42.6656 247.775 47.5683 248.141 53.749C248.152 53.4976 248.183 53.2567 248.183 53.0052C248.183 46.4788 242.893 41.1885 236.367 41.1885H130.005C123.479 41.1885 118.188 46.4788 118.188 53.0052C118.188 53.2567 118.199 53.4976 118.23 53.749C118.597 47.5683 123.72 42.6656 130.005 42.6656Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.141 53.7385C247.754 59.9088 242.631 64.822 236.367 64.822H130.005C123.73 64.822 118.597 59.9193 118.23 53.7385C118.199 53.9899 118.188 54.2309 118.188 54.4718C118.188 60.9983 123.479 66.2886 130.005 66.2886H236.367C242.893 66.2886 248.183 60.9983 248.183 54.4718C248.183 54.2309 248.173 53.9899 248.141 53.7385Z",
    fill: "#212121",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 -28.2453C152.843 -28.2453 173.522 -18.9847 188.502 -4.01468L222.654 -38.1869C222.402 -38.4383 222.161 -38.6897 221.92 -38.9307L188.502 -5.50225C173.522 -20.4722 152.843 -29.7329 130.005 -29.7329C84.3096 -29.7329 47.2775 7.29922 47.2775 52.9949C47.2775 53.2463 47.2879 53.4872 47.2879 53.7386C47.686 8.38871 84.561 -28.2453 130.005 -28.2453Z",
    fill: "#212121",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.005 183.01C201.805 183.01 260.01 124.805 260.01 53.0052C260.01 -18.7947 201.805 -77 130.005 -77C58.2053 -77 0 -18.7947 0 53.0052C0 124.805 58.2053 183.01 130.005 183.01Z",
    fill: "url(#paint0_radial_403_50653)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_403_50653",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.1248 -39.1712) scale(259.561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_50653"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 260,
    fill: "white",
    transform: "translate(0 -77)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleAuthenticator);
export default __webpack_public_path__ + "static/media/google-authenticator.f221171b6169d787f320e703da4409bd.svg";
export { ForwardRef as ReactComponent };